import { GIPHY_API_KEY } from "./common-constants";
export const CLIENT_URL = window.location.origin;
export const DEFAULT_PROFILE_IMG = `${CLIENT_URL}/default_profile.png`;
export const DEFAULT_VIDEO_IMG = `${CLIENT_URL}/default_video.png`;
export const DEFAULT_LIST_IMG = `${CLIENT_URL}/default_list.png`;

export const FIND_USER_LOCATION = "https://ipapi.co/json/";
export const GIPHY_API_URL = `https://api.giphy.com/v1/gifs/search?api_key=${GIPHY_API_KEY}&limit=100&q=`;

export const HELP_TWITTER = "https://help.twitter.com";
export const ACROSS_YOUR_DEVICES = HELP_TWITTER + "/about-personalization-across-your-devices";
// forms
export const HELP_TWITTER_FORMS = HELP_TWITTER + "/forms";
export const REGAIN_ACCESS = HELP_TWITTER_FORMS + "/account-access/regain-access";
export const FORMS_PRIVACY = HELP_TWITTER_FORMS + "/privacy";
// safety-and-security
export const SAFETY_AND_SECURITY = HELP_TWITTER + "/safety-and-security";
export const DATA_THROUGH_PARTNERSHIPS = SAFETY_AND_SECURITY + "/data-through-partnerships";
export const EMAIL_AND_PHONE_DISCOVERABILITY_SETTINGS = SAFETY_AND_SECURITY + "/email-and-phone-discoverability-settings";
export const ACCOUNT_SECURITY_TIPS = SAFETY_AND_SECURITY + "/account-security-tips";
export const PUBLIC_AND_PROTECTED_TWEETS = SAFETY_AND_SECURITY + "/public-and-protected-tweets";
export const BIRTHDAY_VISIBILITY_SETTINGS = SAFETY_AND_SECURITY + "/birthday-visibility-settings";
export const REMOVE_TWITTER_PROFILE_FROM_GOOGLE_SEARCH = SAFETY_AND_SECURITY + "/remove-twitter-profile-from-google-search";
export const PRIVACY_CONTROLS_FOR_TAILORED_ADS = SAFETY_AND_SECURITY + "/privacy-controls-for-tailored-ads";
export const TWEET_LOCATION_SETTINGS = SAFETY_AND_SECURITY + "/tweet-location-settings";
// managing-your-account
export const MANAGING_YOUR_ACCOUNT = HELP_TWITTER + "/managing-your-account";
export const UNDERSTANDING_THE_NOTIFICATIONS_TIMELINE = MANAGING_YOUR_ACCOUNT + "/understanding-the-notifications-timeline";
export const NEW_ACCOUNT_SETTINGS = MANAGING_YOUR_ACCOUNT + "/new-account-settings";
export const HOW_TO_CHANGE_COUNTRY_SETTINGS = MANAGING_YOUR_ACCOUNT + "/how-to-change-country-settings";
export const TWEET_ACTIVITY = MANAGING_YOUR_ACCOUNT + "/updating-email-preferences#tweet-activity";
export const NOTIFICATIONS_ON_MOBILE_DEVICES = MANAGING_YOUR_ACCOUNT + "/notifications-on-mobile-devices";
export const ACCESSING_YOUR_TWITTER_DATA = MANAGING_YOUR_ACCOUNT + "/accessing-your-twitter-data";
export const ACCESS_TO_THIRD_PARTY_APPS = MANAGING_YOUR_ACCOUNT + "/connect-or-revoke-access-to-third-party-apps";
export const TWO_FACTOR_AUTHENTICATION = MANAGING_YOUR_ACCOUNT + "/two-factor-authentication";
export const HOW_TO_UPDATE_YOUR_ACCOUNT_PHONE_NUMBER = "https://help.twitter.com/bg/managing-your-account/how-to-update-your-account-phone-number";
// using-twitter
export const USING_TWITTER = HELP_TWITTER + "/using-twitter";
export const TWEETDECK_TEAMS = USING_TWITTER + "/tweetdeck-teams";
export const TWITTER_SEARCH = USING_TWITTER + "/twitter-search";
export const TAILORED_SUGGESTIONS = USING_TWITTER + "/tailored-suggestions";
export const TWITTER_MUTE = USING_TWITTER + "/twitter-mute";
export const ADVANCED_TWITTER_MUTE_OPTIONS = USING_TWITTER + "/advanced-twitter-mute-options";
export const USING_TWITTER_SPACES = USING_TWITTER + "/spaces";
export const SOMEONE_BLOCKED_ME_ON_TWITTER = USING_TWITTER + "/someone-blocked-me-on-twitter";
export const UPLOAD_YOUR_CONTACTS_TO_SEARCH = USING_TWITTER + "/upload-your-contacts-to-search-for-friends";
export const BLOCKING_AND_UNBLOCKING_ACCOUNTS = USING_TWITTER + "/blocking-and-unblocking-accounts";
export const ADVANCED_TWITTER_BLOCK_OPTIONS = USING_TWITTER + "/advanced-twitter-block-options";
export const DIRECT_MESSAGES = USING_TWITTER + "/direct-messages";
export const DIRECT_MESSAGES_RECEIVE = DIRECT_MESSAGES + "#receive";
export const DIRECT_MESSAGES_RECEIPTS = DIRECT_MESSAGES + "#receipts";
// rules-and-policies
export const RULES_AND_POLICIES = HELP_TWITTER + "/rules-and-policies";
export const MEDIA_POLICY = RULES_AND_POLICIES + "/media-policy";
export const TWITTER_COOKIES = RULES_AND_POLICIES + "/twitter-cookies";
export const TWITTER_NOTICES = RULES_AND_POLICIES + "/notices-on-twitter";

export const DEVELOPER_TWITTER = "https://developer.twitter.com";
export const DEVELOPER_ACCOUNT = "https://developer.twitter.com/support/twitter-api/developer-account";
export const BUSINESS_TWITTER = "https://business.twitter.com/";
export const HOW_TWITTER_ADS_WORK = "https://business.twitter.com/en/help/troubleshooting/how-twitter-ads-work.html?ref=web-twc-ao-gbl-adsinfo&utm_source=twc&utm_medium=web&utm_campaign=ao&utm_content=adsinfo";
export const TWITTER_ADS_WORK = "https://business.twitter.com/en/help/troubleshooting/how-twitter-ads-work.html";
export const ABOUT_TWITTER = "https://about.twitter.com/en";
export const BRAND_TOOLKIT = "https://about.twitter.com/who-we-are/brand-toolkit";
export const CAREERS_TWITTER = "https://careers.twitter.com";
export const MARKETING_TWITTER = "https://marketing.twitter.com";
export const TWITTER_DIRECTORY_PROFILES = "https://twitter.com/i/directory/profiles";
export const STATUS_TWITTER = "https://status.twitterstat.us";
export const PRIVACY_TWITTER = "https://privacy.twitter.com/";
export const TWITTER_TOS = "https://twitter.com/tos";
export const TWITTER_TOS_NEW = "https://twitter.com/tos#new";
export const TWITTER_PRIVACY = "https://twitter.com/privacy";
export const TWITTER_ABOUT = "https://analytics.twitter.com/about";
export const TWITTER_RELEASE_NOTES = "https://twitter.com/i/release_notes";
export const ADS_TWITTER = "https://ads.twitter.com";
export const TWITTER_LOGIN = "https://ads.twitter.com/login";
export const BLOG_TWITTER = "https://blog.twitter.com/";

export const PRODUCTION_URL = "https://opbluebird.com/";
